import * as tslib_1 from "tslib";
import React from 'react';
import { GallectionCentaurCard } from '../../CentaurCard';
import s from './CollectionCard.scss';
export var CollectionCard = function (_a) {
    var _b = _a.collection, isSelected = _b.isSelected, folder = tslib_1.__rest(_b, ["isSelected"]), onClick = _a.onClick;
    var onClickBound = onClick.bind(null, folder.folderId);
    return (React.createElement("button", { className: s['card'], onClick: onClickBound },
        React.createElement(GallectionCentaurCard, { gallection: folder, mode: isSelected ? 'done' : 'default' })));
};
CollectionCard.displayName = 'CollectionCard';
export default CollectionCard;
//# sourceMappingURL=CollectionCard.js.map